import { baseCleanProps } from "common/api/Api";
import { fetcher } from "common/api/Fetcher";
import { IDoorData } from "common/records/Door";
import { HydratedMeasurementRecord } from "common/records/HydratedMeasurement";
import { IMeasurementData } from "common/records/Measurement";
import { IRoomData } from "common/records/Room";
import { IWindowData } from "common/records/Window";

export const measurementRelations = ["roof_faces", "wall_facades", "windows", "doors", "rooms", "decks", "pools"];

export const measurementTypes = <const>[
  "roofing",
  "siding",
  "windows",
  "doors",
  "roof_faces",
  "walls",
  "fencing",
  "sunroom",
  "rooms",
  "decks",
  "pools",
];
export type MeasurementType = (typeof measurementTypes)[number];

export const measurementTools = <const>[
  "annotator",
  "sidinginator",
  "elevation_scaling",
  "rapid_area",
  "satellite_measure",
  "fencing_tool",
];
export type MeasurementTool = (typeof measurementTools)[number];

export const measurementSystems = <const>["imperial", "metric"];
export type MeasurementSystem = (typeof measurementSystems)[number];

export const url = "api/v1/measurements";

export interface IMeasurementResponse {
  measurement: IMeasurementData;
}

export const load = async (id: number, include: string[] = []): Promise<IMeasurementResponse> => {
  const actionUrl = fetcher.joinUrls(url, id.toString());
  return await fetcher.get<IMeasurementResponse>(actionUrl, { "include[]": include });
};

export const update = async (
  measurement: HydratedMeasurementRecord,
  include: string[] = [],
): Promise<IMeasurementResponse> => {
  const actionUrl = fetcher.joinUrls(url, measurement.id.toString());
  const measurementData = cleanProps(measurement);
  return await fetcher.patch<IMeasurementResponse>(actionUrl, {
    measurement: measurementData,
    include,
  });
};

export const cleanProps = (measurement: HydratedMeasurementRecord): any => {
  let measurementData: any = { ...measurement.toJS() };
  measurementData = baseCleanProps(measurementData);

  measurementData.windows_attributes = measurementData.windows.map((window: IWindowData) => baseCleanProps(window));

  delete measurementData.windows;
  delete measurementData.window_ids;

  measurementData.doors_attributes = measurementData.doors.map((door: IDoorData) => baseCleanProps(door));
  delete measurementData.doors;
  delete measurementData.door_ids;

  measurementData.rooms_attributes = measurementData.rooms.map((room: IRoomData) => {
    const props = baseCleanProps(room);
    delete (props as any).annotation;
    return props;
  });
  delete measurementData.rooms;
  delete measurementData.room_ids;

  delete measurementData.levels;
  delete measurementData.locations;
  delete measurementData.elevations;
  delete measurementData.elevation_ids;
  delete measurementData.deck_ids;

  return measurementData;
};
